import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-new-log",
  "use": "icon-new-log-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-new-log\"><path d=\"M448.93 890.09H174.61a42.51 42.51 0 0 1-42.46-42.46V154.18a42.51 42.51 0 0 1 42.46-42.46h551.28a42.51 42.51 0 0 1 42.46 42.46v307.61H712V168.1H188.53v665.62h260.4z\" p-id=\"4460\" /><path d=\"M253.01 241.57h410.51v56.38H253.01zM253.01 372.82h410.51v56.38H253.01zM706.86 915.29c-107.54 0-195-87.49-195-195s87.49-195 195-195 195 87.49 195 195-87.46 195-195 195z m0-333.69c-76.46 0-138.66 62.2-138.66 138.66s62.2 138.66 138.66 138.66 138.66-62.2 138.66-138.66S783.31 581.6 706.86 581.6z\" p-id=\"4461\" /><path d=\"M785.26 742.45h-96.55V617.36h28.19v96.9h68.36v28.19z\" p-id=\"4462\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/new-log.svg
// module id = tx/X
// module chunks = 72